import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { Theme } from 'style-utils/theme';

export const colorMappedProps = {
  textColor: {
    property: 'color',
    themeKey: 'colors',
  },
};

export type WithColorProps = {
  textColor?: string & StyledPropType<string & keyof Theme['colors']>;
};

export const withColor = createExtractCssFromProps(colorMappedProps);
